import React, { useContext } from "react";
import { MObilehandelrContext } from "./Mobilehandelr";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

function Mobilemwn() {
  let { openmenu } = useContext(MObilehandelrContext);
  return (
    <div className={`Mobilemenu ${openmenu ? "active" : ""}`}>
      <motion.ul
        initial={{ opacity: 0, y: -10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.4, ease: "easeInOut" }}
      >
        <NavLink className={"active"} to={"/"}>
          Home
        </NavLink>
        <NavLink to={"/About"}>About</NavLink>
        <NavLink to={"/shop"}>Shop</NavLink>
        <NavLink to={"/contact"}>Contact</NavLink>
      </motion.ul>
    </div>
  );
}

export default Mobilemwn;
